import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { switchDataSet } from '@redux/actions/AuthActions';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import Button from '@material-ui/core/Button';

import {
  MEASUREMENTS1,
  MEASUREMENTS2,
  YEARS,
  COUNTRY_CURRENCY_MKTCAP_EV_A,
  COUNTRY_CURRENCY_MKTCAP_EV_B,
  EV_REVENU_A,
  EV_REVENU_B,
  EV_EBITDA_A,
  EV_EBITDA_B,
  PE_A,
  PE_B,
  EV_REVENU_A_LOW_HIGH_END_A,
  EV_REVENU_A_LOW_HIGH_END_B,
  EV_EBITDA_A_LOW_HIGH_A,
  EV_EBITDA_A_LOW_HIGH_B,
  EV_EBITA_LOW_HIGH_A,
  EV_EBITA_LOW_HIGH_B,
  PE_LOW_HIGH_A,
  PE_LOW_HIGH_B
} from './fakedata2';

const StyledTableCell = withStyles((theme) => ({
  body: {
    borderBottom: 'none !important',
    fontSize: 12,
    width: '100%',
    padding: '3px 24px 3px 16px'
  }
}))(TableCell);

const StyledTableCellStrong = withStyles((theme) => ({
  head: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#6D7278',
    minWidth: 95
  },
  body: {
    borderBottom: 'none !important',
    fontSize: 12,
    fontWeight: 'bold',
    width: '100%'
  }
}))(TableCell);

const TableCellTitle = withStyles((theme) => ({
  body: {
    fontSize: 12,
    borderBottom: 'none !important'
  }
}))(TableCell);

const TableCellTitleStrong = withStyles((theme) => ({
  body: {
    fontSize: 12,
    borderBottom: 'none !important',
    fontWeight: 'bold'
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    // backgroundColor: 'rgba(151,151,151,0.1)',
    border: '2px solid rgba(151,151,151,0.2)'
  }
}))(TableRow);

const StyledTableRowStrong = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(151,151,151,0.3)',
    border: '2px solid rgba(151,151,151,0.2)'
  }
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700
  },
  tableContainer: {},
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    '& h2': {
      fontSize: 20,
      fontWeight: 'bold'
    }
  },
  input: {
    maxWidth: 75,
    width: 75,
    minHeight: 30,
    padding: 10,
    textAlign: 'center',
    border: '2px solid #002380',
    borderRadius: '5px',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  }
}));

const OutputTable = ({ dataSet }) => {
  const [marketCapLow, setMarketCapLow] = useState(800);
  const [marketCapHigh, setMarketCapHigh] = useState(1400);
  const [countryCurrency, setCountryCurrency] = useState(
    COUNTRY_CURRENCY_MKTCAP_EV_A
  );
  const [evRevenu, setEvRevenu] = useState(EV_REVENU_A);
  const [evEbitda, setEvEbitda] = useState(EV_EBITDA_A);
  const [pe, setPE] = useState(PE_A);
  const [evRevenuLowHigh, setEvRevenuLowHigh] = useState(
    EV_REVENU_A_LOW_HIGH_END_A
  );
  const [evEbitdaLowHigh, setEvEbitdaLowHigh] = useState(
    EV_EBITDA_A_LOW_HIGH_A
  );
  const [evEbitaLowHigh, setEvEbitaLowHigh] = useState(EV_EBITA_LOW_HIGH_A);
  const [peLowHigh, setPeLowHigh] = useState(PE_LOW_HIGH_A);
  const classes = useStyles();

  useEffect(() => {
    setCountryCurrency(
      dataSet === 'dataA'
        ? COUNTRY_CURRENCY_MKTCAP_EV_B
        : COUNTRY_CURRENCY_MKTCAP_EV_A
    );
    setEvRevenu(dataSet === 'dataA' ? EV_REVENU_B : EV_REVENU_A);
    setEvEbitda(dataSet === 'dataA' ? EV_EBITDA_B : EV_EBITDA_A);
    setPE(dataSet === 'dataA' ? PE_B : PE_A);
    setEvRevenuLowHigh(
      dataSet === 'dataA'
        ? EV_REVENU_A_LOW_HIGH_END_B
        : EV_REVENU_A_LOW_HIGH_END_A
    );
    setEvEbitdaLowHigh(
      dataSet === 'dataA' ? EV_EBITDA_A_LOW_HIGH_B : EV_EBITDA_A_LOW_HIGH_A
    );
    setEvEbitaLowHigh(
      dataSet === 'dataA' ? EV_EBITA_LOW_HIGH_B : EV_EBITA_LOW_HIGH_A
    );
    setPeLowHigh(dataSet === 'dataA' ? PE_LOW_HIGH_B : PE_LOW_HIGH_A);
  }, [dataSet]);

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      <Table
        aria-label="customized table"
        className={classes.table}
        size="small">
        <TableHead>
          <StyledTableRow>
            {MEASUREMENTS1.map((measure) => (
              <StyledTableCellStrong align="left">
                {measure}
              </StyledTableCellStrong>
            ))}
            {MEASUREMENTS2.map((measure) => (
              <StyledTableCellStrong align="center">
                {measure}
              </StyledTableCellStrong>
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <TableCellTitle />
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {YEARS[1].map((year) => (
                <StyledTableCellStrong>{year}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCellTitle>Lyft</TableCellTitle>
            {countryCurrency[0].map((val) => (
              <StyledTableCell>{val}</StyledTableCell>
            ))}
            <StyledTableCell>
              {evRevenu[0].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitda[0].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {EV_EBITDA_A[0].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {PE_A[0].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCellTitle>Uber Tech.</TableCellTitle>
            {countryCurrency[1].map((val) => (
              <StyledTableCell>{val}</StyledTableCell>
            ))}
            <StyledTableCell>
              {evRevenu[1].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitda[1].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitda[1].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {pe[1].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRowStrong>
            <TableCellTitleStrong>Average</TableCellTitleStrong>
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell>
              {evRevenu[2].map((ev) => (
                <StyledTableCellStrong>{ev}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitda[2].map((ev) => (
                <StyledTableCellStrong>{ev}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitda[2].map((ev) => (
                <StyledTableCellStrong>{ev}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {pe[2].map((ev) => (
                <StyledTableCellStrong>{ev}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
          </StyledTableRowStrong>
          <StyledTableRowStrong>
            <TableCellTitleStrong>Median</TableCellTitleStrong>
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell>
              {evRevenu[3].map((ev) => (
                <StyledTableCellStrong>{ev}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitda[3].map((ev) => (
                <StyledTableCellStrong>{ev}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitda[3].map((ev) => (
                <StyledTableCellStrong>{ev}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {pe[3].map((ev) => (
                <StyledTableCellStrong>{ev}</StyledTableCellStrong>
              ))}
            </StyledTableCell>
          </StyledTableRowStrong>
          <StyledTableRow>
            <TableCellTitleStrong>Issuer</TableCellTitleStrong>
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCellStrong align="center">
              Equity value
            </StyledTableCellStrong>
            <StyledTableCell />
          </StyledTableRow>
          <StyledTableRow>
            <TableCellTitle>Low end</TableCellTitle>
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell align="center">
              <input
                className={classes.input}
                onChange={(e) => setMarketCapLow(e.target.value)}
                type="number"
                value={marketCapLow}
              />
            </StyledTableCell>
            <StyledTableCell align="left">700</StyledTableCell>
            <StyledTableCell>
              {evRevenuLowHigh[0].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitdaLowHigh[0].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitaLowHigh[0].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {peLowHigh[0].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <TableCellTitle>High end</TableCellTitle>
            <StyledTableCell />
            <StyledTableCell />
            <StyledTableCell>
              <input
                className={classes.input}
                onChange={(e) => setMarketCapHigh(e.target.value)}
                type="number"
                value={marketCapHigh}
              />
            </StyledTableCell>
            <StyledTableCell align="left">1300</StyledTableCell>
            <StyledTableCell>
              {evRevenuLowHigh[1].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitdaLowHigh[1].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {evEbitaLowHigh[1].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
            <StyledTableCell>
              {peLowHigh[1].map((ev) => (
                <StyledTableCell>{ev}</StyledTableCell>
              ))}
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const mapStateToProps = (state) => ({
  dataSet: state.AuthReducer.dataSet
});

export const mapDispatchToProps = (dispatch) => {
  return {
    switchData: () => dispatch(switchDataSet())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OutputTable);
